@if (toastService.toasts | async; as toasts) {
  @if (toasts?.length) {
    <div
      class="rt-toasts"
      [style.width]="config.width + 'px'"
      [ngClass]="rtToastsPositionRelatedClasses[config.position]"
    >
      @for (toast of toasts; track toast.id) {
        @if (fadeInTop[config.position]) {
          <ng-container *ngIf="fadeInTop[config.position]">
            <rt-toast
              [@fadeInTop]="'in'"
              [isHoveredContainer]="isHovered"
              [toast]="toast"
            >
            </rt-toast>
          </ng-container>
        } @else {
          <rt-toast
            [@fadeInBottom]="'in'"
            [isHoveredContainer]="isHovered"
            [toast]="toast"
          >
          </rt-toast>
        }
      }
    </div>
  }
}
